import React, { SVGProps } from 'react'
const SvgLocked = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <g fill={props.fill || 'var(--color-cta)'} fillRule="nonzero">
      <path d="M12 3.25a5.751 5.751 0 0 1 5.709 5.058h.791c.382 0 .692.31.692.692v11c0 .382-.31.692-.692.692h-13A.692.692 0 0 1 4.808 20V9c0-.382.31-.692.692-.692h.791A5.751 5.751 0 0 1 12 3.25Zm5.807 6.442H6.192v9.615h11.615V9.692ZM12 4.75a4.251 4.251 0 0 0-4.194 3.557h8.388A4.251 4.251 0 0 0 12 4.75Z" />
      <path d="M12 12.75a.75.75 0 0 1 .743.648l.007.102V16a.75.75 0 0 1-1.493.102L11.25 16v-2.5a.75.75 0 0 1 .75-.75Z" />
    </g>
  </svg>
)
export default SvgLocked
